export default {
  default: () => import("H:/ssd2/vkusilosos-web-main/layouts/default.vue").then(m => m.default || m)
}